module.exports = __webpack_public_path__ + "media/images/gmail_icon-cf6e9da6.svg";